import React from 'react';
import styled from 'styled-components';
import { IFormatterProps } from '../../../@types/workspaceTypes';
import { StyledPill } from '../../StyledPill/StyledPill';

const BooleanFormatter = ({ column, value }: IFormatterProps<any, boolean | `${boolean}`>) => {
  const title = column?.name;

  if (value === true) {
    return <StyledPill title={title}>Yes</StyledPill>;
  }

  return null;
};

export default BooleanFormatter;
